import { ChangeEvent, useCallback, useState } from 'react'

export function useFormValidation() {
  const [value, setValue] = useState('')
  const [error, setError] = useState('')
  const [isValid, setIsValid] = useState(false)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value, validationMessage, validity, type } = event.target

    setValue(value)
    if (validity.typeMismatch && type === 'url') {
      setError(
        'Please make sure your website includes a valid domain (http://example.com)',
      )
    } else {
      setError(validationMessage)
    }

    setIsValid(validity.valid)
  }

  const setCustomError = (message: string) => {
    setError(message)
    setIsValid(false)
  }

  const resetForm = useCallback(() => {
    setValue('')
    setError('')
    setIsValid(false)
  }, [])

  return { value, handleChange, error, isValid, resetForm, setCustomError }
}
